import { render, staticRenderFns } from "./OfferDetailComponent.vue?vue&type=template&id=4d4bc219&scoped=true"
import script from "./OfferDetailComponent.vue?vue&type=script&lang=js"
export * from "./OfferDetailComponent.vue?vue&type=script&lang=js"
import style0 from "./OfferDetailComponent.vue?vue&type=style&index=0&id=4d4bc219&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4bc219",
  null
  
)

export default component.exports